import styles from "./ExtendedReturnsPolicy.module.scss";

type Props = {
  startDate: string;
  endDate: string;
  deadlineDate: string;
};

export function ExtendedReturnsPolicy({
  startDate = "",
  endDate = "",
  deadlineDate = "",
}: Props) {
  if (!startDate || !endDate || !deadlineDate) return null;

  return (
    <div>
      <p className={styles.headline}>Our extended Christmas returns policy</p>
      <p>
        We&apos;ve extended our usual limit for returns just for the festive
        season. Gifts purchased between {startDate} and {endDate} can be
        returned until {deadlineDate} if they&apos;re unwanted or unsuitable.
        Standard product-specific return restrictions still apply.
      </p>
    </div>
  );
}
